<template>
  <span @click="set(book)" class="pointer" v-if="book"
    ><ui-icon name="icon-up" :title="$t('pintop')" v-if="!sticky"></ui-icon>
    <ui-icon name="icon-down" v-if="sticky"></ui-icon
    >{{ $t(sticky ? "cancelPintop" : "pintop") }}</span
  >
</template>
<script>
import api from "../api/index";
export default {
  data() {
    return {
      sticky: false
    };
  },
  props: ["book"],
  mounted() {
    this.sticky = this.book.sticky;
  },
  methods: {
    set(book) {
      if (this.sticky) {
        api
          .unSticky({ aid: book.id })
          .then(res => {
            this.sticky = false;
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        api
          .setSticky({ aid: book.id })
          .then(res => {
            this.sticky = true;
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  }
};
</script>
